import { graphql } from "@/lib/gql/__generated__";

export const VoucherIssuedMarkVoucherAsUnUsed_ECReceiptDetailPage_Mutation = graphql(`
	mutation VoucherIssuedMarkVoucherAsUnUsed_ECReceiptDetailPage($input: VoucherIssuedMarkVoucherAsUnUsedInput!) {
		voucherIssuedMarkVoucherAsUnUsed(input: $input) {
			userErrors
			voucherIssued {
				hotelID
				voucherCode
				userECReceiptID
				usedReservationID
				useableStartDt
				cinStart
				cinEnd
				guestName
				guestEmail
				guestPostalCode
				guestAddress
				guestTel
				giftInfo {
					to
					from
					password
					message
				}
				createdAt
				createdDt
				usedAt
			}
		}
	}
`);
